/**
 * Which side of the app a signed-in user belongs to: the `client` role uses
 * the client portal only; every other role uses the studio app. A routing
 * convenience — the server enforces access on every endpoint.
 */

export const CLIENT_ROLE = 'client';
export const PORTAL_HOME = '/portal';
export const STUDIO_HOME = '/today';

export const isClientRole = (role: string | undefined | null) => (role ?? '').toLowerCase() === CLIENT_ROLE;
